<template>
  <div class="sfcheck">
    <div class="row">
      <div class="col-12 col-lg-9">
        <h6 class="sfcheck__title">Cheques propios disponibles en cartera</h6>
        <div class="table-responsive sfcheck__table-wrap">
          <table class="table table-sm sfcheck__table">
            <thead>
              <tr>
                <th scope="col" class="sfcheck__check-col"></th>
                <th scope="col">
                  <input v-model="numFilter" class="form-control form-control-sm" placeholder="Número"/>
                </th>
                <th scope="col">Banco</th>
                <th scope="col">Emisor</th>
                <th scope="col">Valor</th>
                <th scope="col">Fecha cobro</th>
                <th scope="col">Tipo</th>
              </tr>
            </thead>
            <tbody>
              <tr role="row" v-for="(check, index) in tpChecksFiltered" :key="index" :class="{ 'is-selected': isChecked(check) }">
                <td class="sfcheck__check-col" data-label="">
                  <input type="checkbox" v-model="selectedChecks" :value="check"/>
                </td>
                <td data-label="N°">{{check.number}}</td>
                <td data-label="Banco">{{check.bank_name}}</td>
                <td data-label="Emisor">{{check.name}}</td>
                <td data-label="Valor">$ {{check.amount}}</td>
                <td data-label="Fecha cobro">{{check.date_due}}</td>
                <td data-label="Tipo">
                  <span class="badge" :class="check.check_kind === 'echeq' ? 'badge-info' : 'badge-secondary'">
                    {{ checkKindLabels[check.check_kind] || 'Físico' }}
                  </span>
                </td>
              </tr>
              <tr v-if="tpChecksFiltered.length === 0">
                <td colspan="7" class="sfcheck__empty">No hay cheques en cartera.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="sfcheck__summary">
          <div class="sfcheck__summary-item">
            <span class="sfcheck__summary-label">Cheques seleccionados:</span>
            <span class="sfcheck__summary-value">{{selectedChecks.length}}</span>
          </div>
          <div class="sfcheck__summary-item">
            <span class="sfcheck__summary-label">Monto total:</span>
            <span class="sfcheck__summary-value">$ {{totalAmount}}</span>
          </div>
          <button
            v-if="selectedChecks.length"
            type="button"
            class="sfcheck__clear"
            @click="cancelSelection">
            Vaciar selecci&oacute;n
          </button>
        </div>
      </div>

      <div class="col-12 col-lg-3">
        <h6 class="sfcheck__title">Seleccionados</h6>
        <div class="sfcheck__selected">
          <table class="table table-sm sfcheck__selected-table">
            <tbody>
              <tr role="row" v-for="(check, index) in selectedChecks" :key="index">
                <td>N° {{check.number}}</td>
                <td>$ {{check.amount}}</td>
                <td class="sfcheck__selected-remove">
                  <button type="button" class="sfcheck__icon-btn sfcheck__icon-btn--danger" title="Remover" @click="remove(check)">
                    <i class="bi bi-x-circle-fill"></i>
                  </button>
                </td>
              </tr>
              <tr v-if="selectedChecks.length === 0">
                <td colspan="3" class="sfcheck__empty">Sin cheques.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { CHECK_KIND_LABELS } from '../../constants/checkKind';

export default {
	props: ['checks','endpoint'],
	data() {
		return {
			tpChecks: [],
            selectedChecks:[],
            numFilter:'',
            totalAmount:0,
            checkKindLabels: CHECK_KIND_LABELS,
		}
	},
    mounted() {
        this.getWallet();
        // Solo cheques ya emitidos (con id); los creados localmente no vienen de cartera.
        this.selectedChecks = this.checks.filter(function (el) {return el.id != null;});
    },
	methods: {
        getWallet: function(){
            var vm = this;
            this.$http.get(vm.endpoint)
            .then(response => {
              if(response.data) {
                vm.tpChecks = response.data.data;
              }
            })
            .catch(error => {
              alert(error);
            })
        },
        // Vacía la selección en curso (no confirma nada; el commit lo hace el padre).
        cancelSelection(){
            this.selectedChecks = [];
        },
        remove(check){
            const index = this.selectedChecks.indexOf(check);
            if (index !== -1) this.selectedChecks.splice(index, 1);
        },
        // Resalta la fila si el cheque está en la selección en curso.
        isChecked(check){
            return this.selectedChecks.indexOf(check) !== -1;
        }
	},
    computed:{
        tpChecksFiltered:{
            get: function () {
                let vm = this;
                return this.tpChecks.filter(e => e.number.includes(vm.numFilter));
            }
        },
    },
    watch:{
        // Componente presentacional: recalcula el total y avisa al padre la selección
        // en curso cada vez que cambia. deep para captar altas, bajas y el remove (splice).
        'selectedChecks': {
            deep: true,
            immediate: true,
            handler: function () {
                this.totalAmount = this.selectedChecks.reduce((sum, chk) => sum + (Number(chk.amount) || 0), 0);
                this.$emit('selection-changed', this.selectedChecks);
            }
      },
    }
}
</script>

<style scoped>
.sfcheck__title {
  font-size: 14px;
  font-weight: 600;
  color: var(--text);
  margin-bottom: 10px;
}

/* ---- Tabla de cheques disponibles ---- */
.sfcheck__table-wrap {
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  max-height: 320px;
  overflow-y: auto;
}

.sfcheck__table {
  margin-bottom: 0;
  color: var(--text);
}

.sfcheck__table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: var(--surface-muted);
  color: var(--text-soft);
  border-bottom: 1px solid var(--border);
  font-weight: 600;
  vertical-align: middle;
  white-space: nowrap;
}

.sfcheck__table td {
  border-top: 1px solid var(--border-soft);
  color: var(--text);
  vertical-align: middle;
}

.sfcheck__table tbody tr:hover {
  background: var(--surface-hover);
}

.sfcheck__table tbody tr.is-selected {
  background: color-mix(in srgb, var(--brand) 14%, transparent);
}

.sfcheck__check-col {
  width: 40px;
  text-align: center;
}

.sfcheck__empty {
  text-align: center;
  color: var(--text-muted);
  padding: 16px 0;
}

/* ---- Barra de resumen ---- */
.sfcheck__summary {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
  margin-top: 10px;
  padding: 10px 12px;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  background: var(--surface-subtle);
}

.sfcheck__summary-label {
  color: var(--text-muted);
  margin-right: 6px;
}

.sfcheck__summary-value {
  font-weight: 600;
  color: var(--text);
}

.sfcheck__clear {
  margin-left: auto;
  border: 0;
  background: transparent;
  color: var(--brand);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
}

.sfcheck__clear:hover {
  text-decoration: underline;
}

/* ---- Panel de seleccionados ---- */
.sfcheck__selected {
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  background: var(--surface-subtle);
  max-height: 320px;
  overflow-y: auto;
}

.sfcheck__selected-table {
  margin-bottom: 0;
  color: var(--text);
}

.sfcheck__selected-table td {
  border-top: 1px solid var(--border-soft);
  color: var(--text);
  vertical-align: middle;
  font-size: 13px;
}

.sfcheck__selected-table tr:first-child td {
  border-top: 0;
}

.sfcheck__selected-remove {
  text-align: right;
  width: 40px;
}

/* ---- Botones de icono ---- */
.sfcheck__icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
}

.sfcheck__icon-btn--danger {
  color: #e04141;
}

.sfcheck__icon-btn--success {
  color: #2e9c5a;
}

.sfcheck__icon-btn:hover {
  opacity: 0.8;
}

/* ---- Responsive: en mobile la tabla de 6 columnas se vuelve tarjetas ---- */
@media (max-width: 767px) {
  .sfcheck__table-wrap {
    max-height: none;
    border: 0;
    overflow: visible;
  }

  .sfcheck__table thead {
    display: none;
  }

  .sfcheck__table,
  .sfcheck__table tbody,
  .sfcheck__table tr,
  .sfcheck__table td {
    display: block;
    width: 100%;
  }

  .sfcheck__table tbody tr {
    border: 1px solid var(--border-soft);
    border-radius: 8px;
    margin-bottom: 8px;
    padding: 6px 12px;
  }

  .sfcheck__table td {
    border-top: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 5px 0;
    text-align: right;
  }

  .sfcheck__table td::before {
    content: attr(data-label);
    font-weight: 600;
    color: var(--text-muted);
    text-align: left;
  }

  .sfcheck__table td[data-label=""] {
    justify-content: flex-start;
  }

  .sfcheck__table td[data-label=""]::before {
    content: none;
  }
}
</style>
